import { useSelector } from 'react-redux';
import { orderDataSelector } from '../store/order/order-selector';
import useSearchForm from '../screens/Hotels/common/HotelSearchForm/hooks/useSearchForm';

const useBookButtonLogic = () => {
   const { reservations, totalRoomsCount, totalPrice } = useSelector(orderDataSelector);
   const { guestsParams } = useSearchForm();
   const { adults, kids, rooms } = guestsParams;

   const basePlacesSum = reservations.reduce((acc, reservation) => {
      // @ts-ignore
      return acc + reservation.basePlaces * reservation.count;
   }, 0);

   let disabledBookButton = false;
   let guests = 0;

   if (reservations.length) {
      if (rooms > 1) {
         disabledBookButton = basePlacesSum < (adults + kids.length);

         guests = (adults + kids.length) - basePlacesSum;
      } else {
         disabledBookButton = false;
      }
   }

   return {
      isBookButtonDisabled: disabledBookButton,
      guests
   };
};

export default useBookButtonLogic;
